import type { FC } from 'react'
import React from 'react'
import {
  makeStyles,
  createStyles,
  ThemeProvider,
  createTheme,
} from '@material-ui/core/styles'
import { Checkbox as MuiCheckbox } from '@material-ui/core'

// @ts-expect-error - createTheme palette type issue
const customTheme = createTheme({
  palette: {
    primary: {
      main: '#000433',
    },
  },
})

const useStyles = makeStyles(() =>
  createStyles({
    root: {},
    wrapper: {},
  }),
)

interface IProps {
  ariaLabel?: string
}

const Checkbox: FC<IProps> = ({ ariaLabel, ...rest }) => {
  const classes = useStyles()

  return (
    <ThemeProvider theme={customTheme}>
      <div className={classes.wrapper}>
        <MuiCheckbox
          color="primary"
          inputProps={{ 'aria-label': ariaLabel || '' }}
          {...rest}
        />
      </div>
    </ThemeProvider>
  )
}

export default Checkbox as typeof MuiCheckbox
